import React from 'react';

import LikertQuestion from './LikertQuestion';
import LongTextQuestion from './LongTextQuestion';
import NullQuestion from './NullQuestion';
import MultiSelectQuestion from './MultiSelectQuestion';

const getComponent = (question) => {
  switch (question.type) {
    case 'likert':
    case 'unscored-likert':
    case 'single-select':
      return LikertQuestion;

    case 'long-text':
      return LongTextQuestion;

    case 'multi-select':
      return MultiSelectQuestion;

    default:
      return NullQuestion;
  }
};

const Question = (props) => {
  const QuestionComponent = getComponent(props.question);

  return <QuestionComponent {...props} />;
};

export default Question;
